import React, { useEffect, useState } from 'react';
import LogoutIcon from "./icons/LogoutIcon";
import { NavLink } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import OptionsIcon from "./icons/OptionsIcon";
import ProfileIcon from "./icons/ProfileIcon";
import { removeCredentialsAction } from "../../store/reducers/authSlice";
import { setViewsAction, setRevisionsAction, setRevisionAction, setPageAction } from "../../store/reducers/searchSlice";
import { pageAPI } from "../../api/page";
import OptionsForm from "./forms/OptionsForm";
import Modal from "../modals/Modal";
import OptionsAdminIcon from "./icons/OptionsAdminIcon";
import UserOptionsForm from "./forms/UserOptionsForm";
import classNames from "classnames";
import useLocalStorage from '../../hooks/useLocalStorage';

const NavLinkClass = "nav-link block font-medium text-xs leading-tight uppercase border-x-0 border-t-0 border-b-2 border-transparent rounded-lg px-3 py-2 mr-5 hover:border-transparent hover:bg-gray-300 focus:border-transparent"

interface IHeaderState {
    optionsModalOpen: boolean
    userOptionsModalOpen: boolean
}

const Header = () => {
    const [isClientMode, setIsClientMode] = useLocalStorage('_wp_clientMode', false)
    const dispatch = useAppDispatch()
    const authUser = useAppSelector(state => state.auth.authUser)
    const [state, setState] = useState<IHeaderState>({
        optionsModalOpen: false,
        userOptionsModalOpen: false
    })

    const toggleOptionsModal = () => {
        setState({
            ...state,
            optionsModalOpen: !state.optionsModalOpen
        })
    }

    const toggleUserOptionsModal = () => {
        setState({
            ...state,
            userOptionsModalOpen: !state.userOptionsModalOpen,
        })
    }

    const logout = () => {
        dispatch(setViewsAction([]))
        dispatch(setRevisionAction(null))
        dispatch(setPageAction(null))
        dispatch(setRevisionsAction([]))
        dispatch(pageAPI.util.resetApiState())
        dispatch(removeCredentialsAction())
    }

    const switchModeHandler = (value: boolean) => {
        setIsClientMode(!!value)
    }

    return (
        <>
            <header className="bg-gray-100 text-gray-500 shadow-md">
                <div className="container">
                    <nav className="flex flex-wrap items-center justify-between py-4 w-full">
                        <div className={classNames('flex flex-wrap w-full items-center relative', {
                            'justify-end': authUser?.isTester,
                            'justify-between': !authUser?.isTester,
                        })}>
                            {!!authUser && !authUser.isTester && <div className="flex-grow items-center">
                                <ul className="nav nav-tabs flex flex-row md:flex-row flex-wrap list-none justify-center sm:justify-start">
                                    <li className="nav-item">
                                        <NavLink
                                            to="/"
                                            className={({ isActive }) => NavLinkClass + (isActive ? " bg-gray-300" : "")}
                                        >Revisions</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink
                                            to="/tracing"
                                            className={({ isActive }) => NavLinkClass + (isActive ? " bg-gray-300" : "")}
                                        >Tracing</NavLink>
                                    </li>
                                    {!!authUser?.isAdmin && !isClientMode && <li className="nav-item">
                                        <NavLink
                                            to="/emails"
                                            className={({ isActive }) => NavLinkClass + (isActive ? " bg-gray-300" : "")}
                                        >Last Emails</NavLink>
                                    </li>}
                                    {!!authUser?.isAdmin && !isClientMode && <li className="nav-item">
                                        <NavLink
                                            to="/logs"
                                            className={({ isActive }) => NavLinkClass + (isActive ? " bg-gray-300" : "")}
                                        >Logs</NavLink>
                                    </li>}
                                </ul>
                            </div>}

                            <div className="flex items-center justify-center sm:justify-start w-full sm:w-auto">
                                {!!authUser && !!authUser.isAdmin && <div className="text-gray-500 mr-[50px]">
                                    <label className="flex items-center cursor-pointer">
                                        <input type="checkbox" checked={isClientMode} className="sr-only peer" onChange={e => switchModeHandler(e.currentTarget.checked)} />
                                        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-non rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                        <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Client mode</span>
                                    </label>
                                </div>}
                                {!!authUser && !authUser.isTester && <a className="text-gray-500 hover:text-gray-700 focus:text-gray-700 mr-5" href="#">
                                    <ProfileIcon />
                                </a>}
                                {!!authUser && !authUser.isTester && !!authUser?.isAdmin && !isClientMode && <span
                                    className="text-gray-500 hover:text-gray-700 focus:text-gray-700 mr-5 cursor-pointer"
                                    onClick={toggleOptionsModal}
                                >
                                    <OptionsIcon />
                                </span>}
                                {!!authUser && !authUser.isTester && <span
                                    className="text-gray-500 hover:text-gray-700 focus:text-gray-700 mr-5 cursor-pointer"
                                    onClick={toggleUserOptionsModal}
                                >
                                    <OptionsAdminIcon />
                                </span>}
                                <span
                                    className="text-gray-500 hover:text-gray-700 focus:text-gray-700 cursor-pointer"
                                    onClick={logout}
                                >
                                    <LogoutIcon />
                                </span>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
            {state.optionsModalOpen && <Modal onClose={toggleOptionsModal}>
                <OptionsForm onClose={toggleOptionsModal} />
            </Modal>}

            {state.userOptionsModalOpen && <Modal onClose={toggleUserOptionsModal}>
                <UserOptionsForm onClose={toggleUserOptionsModal} />
            </Modal>}
        </>
    )
}

export default Header;